/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NumberCircle07Icon16Light } from './NumberCircle07Icon16Light';
import { NumberCircle07Icon16Regular } from './NumberCircle07Icon16Regular';
import { NumberCircle07Icon16Solid } from './NumberCircle07Icon16Solid';
import { NumberCircle07Icon20Light } from './NumberCircle07Icon20Light';
import { NumberCircle07Icon20Regular } from './NumberCircle07Icon20Regular';
import { NumberCircle07Icon20Solid } from './NumberCircle07Icon20Solid';
import { NumberCircle07Icon24Regular } from './NumberCircle07Icon24Regular';
import { NumberCircle07Icon24Solid } from './NumberCircle07Icon24Solid';
import { NumberCircle07Icon32Regular } from './NumberCircle07Icon32Regular';
import { NumberCircle07Icon64Regular } from './NumberCircle07Icon64Regular';
var sizes = {
    16: {
        light: NumberCircle07Icon16Light,
        regular: NumberCircle07Icon16Regular,
        solid: NumberCircle07Icon16Solid,
    },
    20: {
        light: NumberCircle07Icon20Light,
        regular: NumberCircle07Icon20Regular,
        solid: NumberCircle07Icon20Solid,
    },
    24: {
        regular: NumberCircle07Icon24Regular,
        solid: NumberCircle07Icon24Solid,
    },
    32: {
        regular: NumberCircle07Icon32Regular,
    },
    64: {
        regular: NumberCircle07Icon64Regular,
    },
};
export var NumberCircle07Icon = forwardRef('NumberCircle07Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
